<template>
    <Layout is-crm class="customers-statistic" :content-class="'content--narrow'">
        <template #default>
            <PaginatedResource
                ref="statisticResource"
                :fetch-method="fetchCustomersStatistic"
                :filter-fields="filters"
                :sorting-fields="sortBy"
                :page-size="pageSize"
            >
                <template
                    #default="{
                        loading,
                        resource,
                        isEmpty,
                        notFound,
                        canLoadMore,
                        loadMore,
                        filter,
                        search,
                    }"
                >
                    <div class="customers-statistic__paginated">
                        <Spinner v-if="loading" />
                        <StatisticFilters :model-value="filters" @search="search" @filter="filter">
                            <h1 v-t="'crm.statistic.title'" />
                        </StatisticFilters>
                        <StatisticResults
                            :items="resource"
                            :is-empty="isEmpty"
                            :not-found="notFound"
                        />
                        <div v-if="canLoadMore" class="customers-statistic__loadmore">
                            <button
                                v-t="'misc.loadmore'"
                                class="button button--big button--blank"
                                type="button"
                                @click="loadMore"
                            />
                        </div>
                    </div>
                </template>
            </PaginatedResource>
        </template>
    </Layout>
</template>

<script>
import { fetchCustomersStatistic } from '../../api/customers';
import PaginatedResource from '@speechki-frontend/shared/PaginatedResource';
import { StatisticFilters, StatisticResults } from '@/statistic/components';
import Layout from '@speechki-frontend/shared/ui/layout/Layout';
import Spinner from '@speechki-frontend/shared/ui/Spinner';

export default {
    name: 'CustomersStatisticPage',
    components: {
        Layout,
        Spinner,
        PaginatedResource,
        StatisticFilters,
        StatisticResults,
    },
    props: {
        sortBy: {
            type: Array,
            default: () => [],
        },
        pageSize: {
            type: Number,
            default: 500,
        },
    },
    data() {
        const dt = new Date();
        const { id: customer } = this.$route.params;
        const month = dt.getMonth() + 1;
        const year = dt.getFullYear();

        return {
            filters: { customer, month, year },
        };
    },
    computed: {
        params() {
            const { customer } = this.filters;
            return { customer };
        },
    },
    methods: {
        fetchCustomersStatistic,
    },
};
</script>

<style lang="scss" src="./CustomersStatisticPage.scss"></style>
